import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  justify-content: space-between;

  h1 {
    display: flex;
    align-items: center;
    font-size: 1.5rem;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.secondary};

    svg {
      fill: ${({ theme }) => theme.colors.secondary};
      width: 1.75rem;
      height: 1.75rem;
      margin-right: 0.5rem;
    }
  }

  .close-div {
    padding: 0;
    height: 20px;

    button {
      color: #fff;
      background-color: ${({ theme }) => theme.colors.tertiary_500};
      width: 20px;
      height: 19px;
      border-radius: 100%;
      padding: 0;
      border: none;

      :hover {
        cursor: pointer;
      }
    }
  }
`;

export const ContentModal = styled.div`
  display: flex;
  flex-direction: column;

  h1 {
    display: flex;
    align-items: center;
    font-size: 1.5rem;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.secondary};

    svg {
      stroke: ${({ theme }) => theme.colors.secondary};
      width: 1.75rem;
      height: 1.75rem;
      margin-right: 0.5rem;
    }
  }

  .checkbox {
    display: flex;
    gap: 0.5rem;
    max-width: 1rem;
    max-height: 1rem;
  }

  .container {
    margin: 1rem 0;

    .containerStatus {
      width: 100%;
      display: flex;
      gap: 4rem;
      align-items: center;
      margin: 1rem 0;

      .contentStatus {
        display: flex;
        align-items: center;
        gap: 0.2rem;

        .MuiCheckbox-root {
          padding: 0;
        }

        .Mui-checked {
          color: ${({ theme }) => theme.colors.tertiary_500};
        }

        label {
          font-size: 1.1rem;
          color: ${({ theme }) => theme.colors.tertiary_500};
          padding: 0;
          cursor: pointer;
        }
        .labelDisabled {
          cursor: auto;
        }
      }
    }
  }

  .containerAttachment {
    display: flex;
    flex-direction: column;

    .contentAttachment {
      display: flex;
      flex-direction: column;
      gap: 1rem;

      .contentDropzone {
        display: flex;
        align-self: center;
      }
    }

    .error {
      color: ${({ theme }) => theme.colors.error};
      display: flex;
      align-items: center;
      align-self: center;
      font-size: 1rem;
      flex-wrap: nowrap;
      margin: 1rem 0;

      svg {
        margin-right: 2px;
        font-size: 1rem;
        padding-bottom: 0.1rem;
      }
    }
  }

  .starService {
    display: flex;
    margin-top: 1rem;

    .escrita {
      display: block;
    }
    text {
      display: block;
      color: ${({ theme }) => theme.colors.gray_300};
      font-size: 1.2rem;
      font-weight: 500;
      margin-right: 0.5rem;
      margin-top: auto;
    }
    span {
      display: flex;
      color: ${({ theme }) => theme.colors.gray_275};
    }
    .star {
      margin-left: 5.5rem;
    }
    button {
      border: none;
      background: transparent;
      margin-left: -0.5rem;
    }
  }

  .content-buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10rem;
    padding-top: 2rem;
  }

  .CommentService {
    margin-top: 2.5rem;
    span {
      color: ${({ theme }) => theme.colors.gray};
      font-size: 1rem;
      font-weight: 500;
      margin-right: 0.5rem;
      margin-top: auto;
    }

    .Note {
      margin-top: 0.7rem;
      border: 1px solid ${({ theme }) => theme.colors.primary};
      height: 6rem;
      width: 95% !important;
      resize: none;
      font-family: 'Futura PT' !important;
      font-size: 1rem;
      padding: 0.5rem;
      border-radius: 1rem;
      border-width: 0.14rem;
    }
  }
`;
